import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const CompanyAddressSchema = z.object({
    street: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    country: z.string().optional().nullable(),
    postalCode: z.string().optional().nullable(),
}).optional();

export const CompanyContactSchema = z.object({
    email: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    fax: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
}).optional();

export const CompanySchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    code: z.string().optional().nullable(),
    taxNumber: z.string().optional().nullable(),
    description: z.string().optional(),
    logo: z.string().optional(),
    address: CompanyAddressSchema,
    contact: CompanyContactSchema,
    parent: optionalMongoObjectId,
    sector: z.string().optional().nullable(),
    employeeCount: z.number().optional().nullable(),
    status: z.enum(['active', 'inactive']).optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});

export const CreateCompanySchema = CompanySchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateCompanySchema = CreateCompanySchema.partial().extend({
    name: z.string().min(1).optional(),
});
export const CompanyFormSchema = CreateCompanySchema;

export const COMMITTEE_MEMBER_OPTIONS = [
    { value: 1, label: 'John Doe' },
    { value: 2, label: 'Jane Smith' },
    { value: 3, label: 'Mike Johnson' },
    { value: 4, label: 'Sarah Wilson' },
    { value: 5, label: 'David Brown' },
    { value: 6, label: 'Lisa Davis' },
    { value: 7, label: 'Tom Wilson' },
    { value: 8, label: 'Anna Taylor' },
];
